<template>
  <div class="aaa">
    <div style="margin-bottom: 10px;">
      <el-tag @click="copyHtml">复制html</el-tag>
      <el-popover placement="right" width="250" trigger="click">
        <div class="ep" v-html="value" :dir="isArabic ? 'rtl' : 'ltr'"></div>
        <el-tag type="success" slot="reference">预览</el-tag>
      </el-popover>
      <el-popover placement="right" width="250" trigger="click" v-model="popModel">
        <el-input type="textarea" v-model="parseText"></el-input>
        <div style="text-align: right;padding-top: 10px;">
          <el-tag @click="save" style="margin-right: 0;">保存</el-tag>
        </div>
        <el-tag type="success" slot="reference">设置html</el-tag>
      </el-popover>
      <input id="a1" type="text" style="opacity: 0;width: 1px; height: 1px;">
    </div>
    <div style="border: 1px solid #ccc;" :dir="isArabic ? 'rtl' : 'ltr'">
      <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
      <div @click="focusHandle">
        <Editor style="height: 500px; overflow-y: hidden;" v-bind:value="html" @input="inputMethods" v-model="html"
          :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated"/>
      </div>
    </div>
    <el-card class="box-card" v-if="boxShow">
      宽：<el-input type="number" placeholder="请输入宽" v-model="width" style="width: 200px;" maxlength="10" show-word-limit>
      </el-input>
      <br>
      <div style="margin-top: 10px;">
        高：<el-input type="number" placeholder="请输入高" v-model="height" style="width: 200px;" maxlength="10"
          show-word-limit>
        </el-input>
      </div>
      <br>
      <div style="text-align: center;margin-top: 10px;">
        <el-button size="mini" @click="sureChangeSize">确定</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import './resizeImg'
import { SlateTransforms, updateImageNode } from '@wangeditor/editor'
import { DomEditor, } from '@wangeditor/core'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '@/store'
export default {
  components: { Editor, Toolbar },
  props: {
    value: String
  },
  data() {
    return {
      width: '',
      height: '',
      imgStyle: {},
      boxShow: false,
      popModel: false,
      parseText: '',
      editor: null,
      html: '<p></p>',
      isArabic: false,
      toolbarConfig: {
      },
      editorConfig: {
        hoverbarKeys: {
          'image': {
            // 清空 image 元素的 hoverbar
            menuKeys: [
              'imageWidth30',
              'imageWidth50',
              'imageWidth100',
              'editImage',
              'viewImageLink',
              'deleteImage',
              'setSize'
            ],
          }
        },
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            server: '/api/upload',
            async customUpload(file, insertFn) {                   // JS 语法
              const formData = new FormData()
              formData.append('file', file)
              formData.append('cover', 0)
              formData.append('dir', 'official/')
              console.log(this);
              const { data: res } = await service.post(
                store.getters.path.hostmgr_upload +
                '?username=' +
                store.getters.username +
                '&token=' +
                store.getters.token,
                formData
              )
              insertFn(res.data, '', res.data)
            }
          },
          uploadVideo: {
            server: '/api/upload',
            async customUpload(file, insertFn) {                   // JS 语法
              const formData = new FormData()
              formData.append('file', file)
              formData.append('cover', 0)
              formData.append('dir', 'official/')
              const { data: res } = await service.post(
                store.getters.path.hostmgr_upload +
                '?username=' +
                store.getters.username +
                '&token=' +
                store.getters.token,
                formData
              )
              insertFn(res.data, '', res.data)
            }
          }
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.isArabic = this.checkArabicInHtml(newVal)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 检测文本是否包含阿语字符
    detectArabic(text) {
      if (!text) return false
      // 阿语字符范围：U+0600-U+06FF
      const arabicRegex = /[\u0600-\u06FF]/
      return arabicRegex.test(text)
    },
    // 从HTML中提取纯文本并检测阿语
    checkArabicInHtml(html) {
      if (!html) return false
      // 创建临时DOM元素来提取纯文本
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = html
      const textContent = tempDiv.textContent || tempDiv.innerText || ''
      return this.detectArabic(textContent)
    },
    focusHandle() {
      this.boxShow = false
    },
    save() {
      this.editor.setHtml(this.parseText)
      this.popModel = false
      this.parseText = ''
    },
    copyHtml() {
      let Url2 = document.getElementById('a1')
      // 使用统一的格式化方法，确保copy和提交格式一致
      Url2.value = this.getFormattedHtml()
      Url2.select()
      document.execCommand("copy");
      this.$message.success('copy success');
    },
    inputMethods(value) {
      // 检测是否包含阿语字符
      this.isArabic = this.checkArabicInHtml(value)
      this.$emit("input", value)
    },
    getBaseBody() {
      return this.editor.getText()
    },
    // 获取格式化后的HTML，如果包含阿语则自动添加dir="rtl"属性
    // 这个方法用于copy和提交，确保两者格式一致
    getFormattedHtml() {
      let htmlContent = this.editor.getHtml()
      
      // 如果检测到阿语，为HTML内容添加dir="rtl"属性
      if (this.isArabic) {
        // 检查是否已经有dir属性
        if (!htmlContent.includes('dir=')) {
          // 如果HTML内容没有根容器，添加一个div包装
          if (!htmlContent.includes('<div') || htmlContent.trim().startsWith('<p>')) {
            htmlContent = `<div dir="rtl">${htmlContent}</div>`
          } else {
            // 如果已有div容器，添加dir属性
            htmlContent = htmlContent.replace(/<div([^>]*)>/i, '<div$1 dir="rtl">')
          }
        } else {
          // 如果已有dir属性，确保是rtl
          htmlContent = htmlContent.replace(/dir=['"]?[^'">\s]*['"]?/i, 'dir="rtl"')
        }
      }
      
      return htmlContent
    },
    async execImgFn(imageNode) {

      if (imageNode == null) return

      const hoverbar = DomEditor.getHoverbar(this.editor)
      if (hoverbar) hoverbar.hideAndClean()
      const { style = {} } = imageNode
      this.imgStyle = style
      setTimeout(() => {
        this.boxShow = true
      }, 10);


    },
    sureChangeSize() {
      const props = {
        style: {
          ...this.imgStyle,
          width: this.width + 'px', // 修改 width
          height:  this.height + 'px', // 清空 height
        },
      }

      this.editor.restoreSelection()
      SlateTransforms.setNodes(this.editor, props, {
        match(n) {
          return DomEditor.checkNodeType(n, 'image')
        }
      })
      this.boxShow = false
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      editor.on('execImgFn', (val) => {
        this.execImgFn(val)
      })
    },
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>
<style scoped lang="scss">
.aaa {
  position: relative;
}

.el-tag {
  margin-right: 20px;
  cursor: pointer;
}

strong {
  font-weight: bold;
}

.aaa {
  a {
    color: initial;
    text-decoration: initial;
    -webkit-backface-visibility: initial;
  }
}


.box-card {
  position: absolute;
  top: 200px;
  left: 200px;
}

.ep {
  overflow: auto;
}
</style>
